import React from 'react';

export default function SpeakerList() {
  return (
    <section className="speaker-list bg-light-blue pt-120 pb-80">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5">
            <div className="text-center mb-5">
              <h2>Meet the Speakers from this Zogros</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-1.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">Frankie Thomas</h5>
              <span className="small fw-bold">Graphics Designer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-2.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">Frankie Thomas</h5>
              <span className="small fw-bold">Graphics Designer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-3.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">Steven Marks</h5>
              <span className="small fw-bold">Web Developer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-4.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">Marcus Schott</h5>
              <span className="small fw-bold">Digital Marketer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-5.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">Antonio Barnes</h5>
              <span className="small fw-bold">Graphics Designer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-6.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">Daniel Armstrong</h5>
              <span className="small fw-bold">Graphics Designer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-1.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">William Lipscomb</h5>
              <span className="small fw-bold">Graphics Designer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="single-speaker mb-4">
              <img
                src="assets/img/event/speakers/sp-1.png"
                alt="speaker"
                width="100"
                className="mb-3"
              />
              <h5 className="h6 m-0">George Coburn</h5>
              <span className="small fw-bold">Graphics Designer</span>
              <div className="sp-social mt-3">
                <a href="/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
